import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.institute.popup.ports');
import { OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-institute-popup-ports',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.institute.popup.ports/view.scss */
/* src/app/portal.institute.popup.ports/view.scss: no such file or directory */`],
})
export class PortalInstitutePopupPortsComponent implements OnInit {
    @Input() preset: any = [];
    @Input() label: any = [];
    @Output() select = new EventEmitter<any>();
    @Output() cancel = new EventEmitter<any>();

    public ports: any = [];
    public selected: any = [];
    public keyword: string = '';

    constructor(@Inject( Service) public service: Service) {
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load(loc: string | null = null) {
        const { code, data } = await wiz.call("load");
        this.ports = data;
        for (let i = 0; i < this.preset.length; i++) {
            this.selected.push(this.preset[i]);
        }

        await this.service.render();
    }

    public match(item: any) {
        if (this.keyword.length == 0) return true;
        let keyword = this.keyword.toLowerCase()
        if (item.ifAlias.toLowerCase().indexOf(keyword) >= 0) return true;
        if (item.ifName.toLowerCase().indexOf(keyword) >= 0) return true;
        return false;
    }

    public find(item: any) {
        for (let i = 0; i < this.selected.length; i++) {
            if (this.selected[i].id == item.id) {
                return this.selected[i];
            }
        }
        return null;
    }

    public async addIn(item: any) {
        let preset = this.find(item);
        if (!preset) {
            preset = JSON.parse(JSON.stringify(item));
            this.selected.push(preset);
        }
        preset.in = true;
        await this.service.render();
    }

    public async addOut(item: any) {
        let preset = this.find(item);
        if (!preset) {
            preset = JSON.parse(JSON.stringify(item));
            this.selected.push(preset);
        }
        preset.out = true;
        await this.service.render();
    }

    public async removeIn(item: any) {
        let preset = this.find(item);
        preset.in = false;
        // if (!preset.out && !preset.in) this.selected.remove(preset);
        if (!preset.out && !preset.in) {
            const idx = this.selected.indexOf(preset);
            if (idx > -1) this.selected.splice(idx, 1);
        }

        await this.service.render();
    }

    public async removeOut(item: any) {
        let preset = this.find(item);
        preset.out = false;
        // if (!preset.out && !preset.in) this.selected.remove(preset);
        if (!preset.out && !preset.in) {
            const idx = this.selected.indexOf(preset);
            if (idx > -1) this.selected.splice(idx, 1);
        }
        await this.service.render();
    }


    public async hide() {
        this.cancel.emit();
    }

    public async action() {
        let selected = JSON.parse(JSON.stringify(this.selected));
        this.select.emit(selected);
    }
}

export default PortalInstitutePopupPortsComponent;